import React from "react";
import {
	faFacebookF,
	faTwitter,
	faInstagram,
	faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Footer2 = () => {
	const scrollToSection = (sectionId) => {
		const section = document.getElementById(sectionId);
		if (section) {
			section.scrollIntoView({ behavior: "smooth" });
		}
	};

	return (
		<footer 
			className="footer_area" 
			style={{
				padding: '30px 0',
				marginTop: '40px',
				backgroundColor: '#f8f9fa'
			}}
		>
			<div className="container">
				<div className="row">
					<div className="col social">
						<div className="single-footer-widget text-center">
							<p style={{
								margin: '0 0 10px 0',
								fontSize: '16px',
								fontFamily: 'Poppins, sans-serif',
								color: '#4a4a4a'
							}}>
								Always Here, Always Redi
							</p>
							<p style={{
								margin: '0',
								fontSize: '14px',
								fontFamily: 'Didact Gothic, sans-serif',
								color: '#747794'
							}}>
								Redi Platforms, LLC
							</p>
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer2;